import React from 'react';
import * as Sentry from '@sentry/react';

// Create a Sentry error boundary component
const SentryErrorBoundary = Sentry.withErrorBoundary(
  ({ children }) => children,
  {
    // Configure error boundary options
    fallback: ({ error, componentStack, resetError }) => (
      <div style={{ 
        padding: '20px', 
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif'
      }}>
        <h2>Something went wrong</h2>
        <p>We've been notified and are working to fix this issue.</p>
        <button 
          onClick={resetError}
          style={{
            padding: '10px 20px',
            backgroundColor: '#007bff',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          Try again
        </button>
        {process.env.NODE_ENV === 'development' && (
          <details style={{ marginTop: '20px', textAlign: 'left' }}>
            <summary>Error details (development only)</summary>
            <pre style={{ 
              backgroundColor: '#f8f9fa', 
              padding: '10px', 
              borderRadius: '4px',
              overflow: 'auto'
            }}>
              {error.toString()}
              {componentStack}
            </pre>
          </details>
        )}
      </div>
    ),
  }
);

// Create a Sentry performance monitoring component
const SentryPerformanceMonitor = Sentry.withProfiler(
  ({ children }) => children,
  {
    name: 'App',
    includeUpdates: true,
    includeRender: true,
  }
);

// Combined wrapper component
const SentryWrapper = ({ children }) => {
  return (
    <SentryErrorBoundary>
      <SentryPerformanceMonitor>
        {children}
      </SentryPerformanceMonitor>
    </SentryErrorBoundary>
  );
};

export default SentryWrapper;
